import { Category } from './types'

export const flattenAdvices = (categories: Category[]) => {
  const uniqueAdviceObjects = [
    ...new Set(
      categories.flatMap((category) =>
        category.topics
          ? category.topics
              .flatMap((topic) => topic.articles)
              .filter((article) => article !== null)
          : [],
      ),
    ),
  ].filter((article) => article !== undefined)

  const uniqueAdviceTitles = [
    ...new Set(
      uniqueAdviceObjects
        .filter((a) => a.title !== undefined)
        .map((advice) => advice.title),
    ),
  ]

  const uniqueAdvice = uniqueAdviceTitles.map((advice) => ({
    title: advice,
    language: categories[0].language,
    slug: uniqueAdviceObjects.find((a) => a.title == advice)!.slug,
    description: uniqueAdviceObjects.find((a) => a.title == advice)!
      .description,
    tags: uniqueAdviceObjects.find((a) => a.title == advice)!.tags,
  }))

  return uniqueAdvice.map((advice) => ({
    ...advice,
    categories: categories
      .filter((category) =>
        category.topics
          ? category.topics.some(
              (topic) =>
                topic.articles &&
                topic.articles.some((article) => article.slug == advice.slug),
            )
          : false,
      )
      .map((category) => ({
        title: category.title,
        language: category.language,
        slug: category.slug,
      })),
    topics: categories
      .flatMap((category) =>
        category.topics
          ? category.topics.filter(
              (topic) =>
                topic.articles &&
                topic.articles.some((article) => article.slug == advice.slug),
            )
          : [],
      )
      .filter((c) => c !== undefined)
      .map((topic) => ({
        title: topic.title,
        language: topic.language,
        slug: topic.slug,
      })),
  }))
}
